import React, { useEffect, useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {  Button, Card, CardContent, Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import { createBrowserHistory } from "history";
import { useHistory } from "react-router-dom";
import phoneIcon from "../../../utils/assests/smartphone.png";
import WhiteCard from "../../../Common/WhiteCard";
import axios from "../../../utils/http";
import { APP_COUNT } from "../../../utils/urls";
import Rejected from "../Rejected";
import Pending from "../Pending";
import Received from "../Received";
import Header from "../../../Common/header";
import Loader from "../../../Common/Loader";

const history = createBrowserHistory();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxRoot: {
      "@media (min-width: 1280px)": {
        height: "100vh",
        padding: "25px",
        border: "1px transparent grey",
        boxShadow: "0 24px 55px 10px rgb(13 12 12 / 30%)",
        borderRadius: "5px",
      },
      [theme.breakpoints.down("xs")]: {
        height: "100vh",
        padding: "20px",
        border: "1px transparent grey",
        boxShadow: "0 24px 55px 10px rgb(13 12 12 / 30%)",
        borderRadius: "5px",
      },
      [theme.breakpoints.between("sm", "md")]: {
        height: "100vh",
        padding: "20px",
        border: "1px transparent grey",
        boxShadow: "0 24px 55px 10px rgb(13 12 12 / 30%)",
        borderRadius: "5px",
      },
    },
    root: {
      flexGrow: 1,
      padding: "10px",
    },
    cardRoot: {
      minWidth: 275,
      border: "1px solid transparent",
      backgroundColor: "#DA222C",
      borderRadius: "24px",
      color: "#fff",
    },
    rootBtn: {
      backgroundColor: "#fff",
      color: "#DA222C",
      borderRadius: "24px",
      width: "70%",
      marginTop: "25px",
    },
  })
);

export default function Dashboard() {
  const history = useHistory();

  const [data, setData] = useState({
    completed: 0,
    pending: 0,
    rejected: 0,
    received: 0,
  });
  const [loader, setLoader] = useState(true);

  const [clickPending, setClickpending] = useState(false);

  useEffect(() => {
    axios
      .get(APP_COUNT)
      .then((response) => {
        setData({ ...response.data.results });
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  }, []);

  const classes = useStyles();

  const onContinue = async (value: any) => {
    if (value === "received") {
      history.push("/received-leads");
    } else if (value === "complete") {
      history.push("/completed-leads");
    } else if (value === "pending") {
      history.push("/pending-leads");
    } else if (value === "rejected") {
      history.push("/rejected-leads");
    }
  };

  const handleContinue = () => {
    history.push("/register");
  };

  return loader ? (
    <Loader loading={true} />
  ) : (
    <Box sx={{ mt: 7 }}>
      <div style={{ backgroundColor: "white" }}>
        <Header pageName="Dashboard" />
      </div>
      <div className="newCard">
        <Grid className="dashBoardGrid" container spacing={2}>
          <WhiteCard
            image={phoneIcon}
            heading={`${data.received}`}
            subheading="Invoice Upload"
            onClickButton={() => {
              // onContinue("received");
            }}
            color="#B4B2EE"
          />

          <WhiteCard
            image={phoneIcon}
            heading={`${data.completed}`}
            subheading="Application Completed"
            onClickButton={() => onContinue("complete")}
            color="#BAE396"
          />

          <WhiteCard
            image={phoneIcon}
            heading={`${data.pending}`}
            subheading="Invoice Verified Pending"
            onClickButton={() => onContinue("pending")}
            color="rgb(254, 124, 124)"
          />

          <WhiteCard
            image={phoneIcon}
            heading={`${data.rejected}`}
            subheading="Application Rejected"
            onClickButton={() => onContinue("rejected")}
            color="#DA222C"
          />
        </Grid>

        <Box sx={{ mt: 3, pt: 3, pb: 3 }} className="redCard">
          <Grid container justifyContent="center">
            <Grid item>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <img
                    src={phoneIcon}
                    alt="phone"
                    height="110px"
                    width="auto"
                  />
                </Grid>
                <Grid item xs={9}>
                  <Box component="div" textAlign="left">
                    <Box sx={{ m: 0, mb: 1 }} component="h3">
                      Create New User
                    </Box>
                    <Typography variant="body2" component="h4">
                      Enter your registered Email ID/ Phone Number
                    </Typography>
                    <Button
                      variant="outlined"
                      color="secondary"
                      className="continueBtn"
                      onClick={handleContinue}
                    >
                      Continue
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </div>
    </Box>
  );
}
